export default from './LoadingContainer';



// WEBPACK FOOTER //
// ./src/components/LoadingContainer/index.js